import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface SetCountertopMaterialArgs {
	materialKey: string;
}

export const setCountertopMaterialTool = (blueprint: Blueprint, { materialKey }: SetCountertopMaterialArgs): ToolResult => {
	if (!materialKey) return { success: false, error: 'Missing materialKey. Use get_countertop_material_options to get valid material keys.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	kitchen.material.setCountertop(materialKey);
	return { success: true, message: `Countertop material set to ${materialKey}.` };
};
